// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Icon__icon{background:no-repeat 50%/contain;display:inline-block;filter:invert(0)}[data-theme=dark] .Icon__icon{filter:invert(1)}", "",{"version":3,"sources":["webpack://./client/components/Icon.css"],"names":[],"mappings":"AAAA,YACE,gCAAoC,CACpC,oBAAqB,CACrB,gBACF,CAEA,8BACE,gBACF","sourcesContent":[".icon {\n  background: no-repeat center/contain;\n  display: inline-block;\n  filter: invert(0);\n}\n\n[data-theme=\"dark\"] .icon {\n  filter: invert(1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "Icon__icon"
};
export default ___CSS_LOADER_EXPORT___;
